<template>
  <section class="content-register-text">
    <Breadcrumb :links="links" :data="{type: 'Text', name:  textData?.title, id: textData?.id}"/>
    <form class="content-register-text-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input type="text" v-model="text.title" name="title" value="" placeholder="Título" required/>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <textarea v-model="text.description" name="description" placeholder="Descrição" required></textarea>
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Tarefas',
          routerName: 'Tasks'
        },
        {
          name: 'Menu',
          routerName: 'MenuTasks'
        },
        {
          name: 'Cadastrar Conteúdo',
          routerName: 'RegisterContents'
        },
        {
          name: 'Texto',
          routerName: 'Text'
        },
      ],
      text: {
        id_user: '',
        id_task: '',
        title: '',
        description: '',
      }
    }
  },
  computed: {
    ...mapGetters('Tasks', ['currentTask']),
    ...mapGetters('User', ['user']),
    ...mapGetters({ textData: 'Tasks/text' }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions('Tasks', ['registerText']),
    async handleSubmit(){
      let message = this.text?.id ? 'Texto editado com sucesso!' : 'Texto cadastrado com sucesso!';

      this.text.id_user = this.user.id;
      this.text.id_task = this.currentTask.id;

      await this.registerText(this.text);
      this.$router.push({ name: 'RegisterContents' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
  },
  async mounted() {
    if (Object.keys(await this.currentTask).length > 0){
      this.links[0].name = this.currentTask.name;
    }
    if (Object.keys(await this.textData).length > 0) {
      this.text = this.textData;
      this.links[3].name = this.text.title;
    }
  }
}
</script>

<style lang="scss" scoped>
.content-register-text {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
